import React, { useEffect, useState , useRef } from "react";
//import axios from '../../../node_modules-back/axios';
import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { getUrl } from "../../ApiCall/GetUrl";

import {  useLocation  , useNavigate } from "react-router-dom";

//import DialogCard from './Dialogs/DialogCard';
import DialogCard from "../Client/Gerry/ClientMenu/AgendaUnaCita/Dialogs/DialogCard";

import { Toast } from 'primereact/toast';


import Footer from "../Footer/Footer";
// Importación de los estilos
import "../../styles/ConsultaExpress.css"

import { ApiCallPost } from "../../ApiCall/ApiCall";



const onError = (e) => {
  console.log("onError: ", e)
}


export default function ConsultaExpress() {
  const [especialidades, setEspecialidad] = useState([])
  const [lugares, setLugar] = useState([])
  const [costos, setCosto] = useState([])


  const [valueEspecialidad, setValueEspecialidad] = useState(-1);
  const [boolDescription, setBoolDescription] = useState(true);
  const [registrado, setRegistrado] = useState(false);
  const [isVisible , setIsVisible] = useState( false ) ; // De entrada no se ve el dialogo 

  var navigate = useNavigate()

   const location = useLocation();

   const toast = useRef()


   console.log( "Location = ***" , location.state ) ;


   function theNotVisible()
   {
    console.log( "theNotVisible")
    setIsVisible( false )
   }

   function theAnswer( val )
   {
    console.log( "theAnswer " , val )

    location.state.id = val.id ;
    location.state.name = val.name ; 

    onMeeting() 

   }




   const onMeeting = () => {

      // var meetNumber = document.getElementById( "meetingNumber").value

      // if ( meetNumber === "")
      // {
      //   alert( "No se proporciono el meeting Number")
      //   return ;
      // }

      // alert( "Ya tenemos todo para el meeting")

      //navigate( "/meeting" , { state : { meetingNumber : meetNumber  } })

      var lugar = document.getElementById( "lugar").value ;


      console.log( "Location ==== " , location.state ) ;

      //return ;


      console.log( "Antes de pagos " , {state : { id :  location.state.id , 
        logg_express : !registrado , especialidad_express : valueEspecialidad , 
        comentario_express : document.getElementById("description").value , 
        estado_express : lugar , name : location.state.name ,   date_express : new Date() }} )

        //return ;

        if ( location.state.id === 0 )
        {
          console.log( "state.id = 0 ")
          setIsVisible( true ) ; // Activamos el login
          return ;
        }
      
      navigate('/pagos' , {state : { id :  location.state.id , 
        logg_express : !registrado , especialidad_express : valueEspecialidad , 
        comentario_express : document.getElementById("description").value , 
        estado_express : lugar , name : location.state.name ,   date_express : new Date() }})


      // if ( location.state.isLawer )
      // {
      //   window.open( 'https://lawyer.legaltek.digital' , '_blank')
      // }
      // else{
      //   window.open( 'https://conference.legaltek.digital' , '_blank')
      // }

      
    
   }



  const onSubmit = async (data) => {

    //data.preventDefault()

    // description
    // lugar  estado_express 
    // valueEspecialidad
    // 

    var lugar = document.getElementById( "lugar").value ;

    console.log( "valueEspecialidad " + valueEspecialidad)
    console.log( "lugar " + document.getElementById( "lugar").value )
    console.log( "description " + document.getElementById( "description").value )
    console.log( "Estado = " + lugar )


    setRegistrado( !registrado )

/*   ApiCallPost( "/client_set_agenda" , { id : location.state.id , 
        logg_express : !registrado , especialidad_express : valueEspecialidad , 
        comentario_express : document.getElementById("description").value , estado_express : lugar ,  date_express : new Date() } )
    .then( (res) => {

        console.log( "Respuesta " ,  res )

        if ( res.status === 0 )
        {
            if ( registrado === false )
            {
              alert("Consulta Express registrada")
            }
            else{
              alert("Consulta Express eliminada")
            }
            
            setRegistrado( !registrado )
            
        }

    })
    .catch( (err) => {

        console.log( err )
        alert("Error al registrar la consulta express")


    })
*/

}


  const changeValue = (n)=>  {
    console.log("valueEspecialidad: ", valueEspecialidad);
    setValueEspecialidad(n);
    n === -1 ? setBoolDescription(true): setBoolDescription(false);
  }


  useEffect(() => {

    if ( location.state === null || location.state === undefined )
      {
        navigate( "/session")
       return ;
      }

    axios.get(getUrl() + "/get_especialidades_express").then(response => {
      setEspecialidad(response.data);
      console.log("Este es el response.data: ", response.data)
    }).catch(error => {
      console.log("Error fetching data: ", error)
      setEspecialidad(["Hubo un error al obtener la información"])
    });

    // axios.get(getUrl() + "/get_costos_express").then(response => {
    //   setCosto(response.data);
    //   console.log("Este es el response.data: ", response.data)
    // }).catch(error => {
    //   console.log("Error fetching data: ", error)
    // });

    axios.get(getUrl() + "/get_states_express").then(response => {
      setLugar(response.data);
      console.log("Este es el response.data: ", response.data)
    }).catch(error => {
      console.log("Error fetching data: ", error)
    });

  }, [])


  const [colorWarning, setColorWarning] = useState(false);
  const handleColorWarning = () => {
    setColorWarning(true)
  }

  const {
    register,
    handleSubmit,
    clearErrors,
    control,
    formState: {
      errors
    }
  } = useForm();

  return (
    <>
      <div className="mt-5 container contenedor">
        <h1 className="mb-3">Consulta Express</h1>
        <div> 
          <p>{location.state?.name}</p>
        </div>
        <Form onSubmit={handleSubmit(onSubmit, onError)} id="formulario">
          <div className="row g-0 d-flex">
            <div className="col-sm-6 m-auto">
              <div className="form-group blocks">
                <label htmlFor="description" className="label-style">Descripción del problema</label>
                <textarea id="description" className="text-area-style"
                {...register("problem_description", {
                  required: {
                    value: boolDescription,
                    message: "Este campo es requerido"
                  },
                })}
                ></textarea>

                {
                    errors?.problem_description?.type === "required" && (
                      <p className="warning-message">
                        {
                          errors.problem_description.message
                        }</p>
                    )
                  }              
              </div>
            </div>
          </div>

          <div className="row g-0 d-flex">
            <div className="col-sm-6 m-auto">
              <div className="form-group blocks">
                <label htmlFor="lugar" className="label-style">¿Dónde estás ubicado?</label>
                <select id="lugar" className="form-control rounded-0 border-0 border-end border-bottom productos-select"
                  {...register("lugar", {
                    required: {
                      value: true,
                      message: "Este campo es requerido."
                    }
                  })}
                  isClearable={true}

                >
                  <option></option>
                  {
                    lugares.map(v => <option key={
                      v.id_state
                    }
                      value={
                        v.id_state
                      }>
                      {
                        v.name
                      }</option>)
                  }
                </select>

                {
                    errors?.lugar?.type === "required" && (
                      <p className="warning-message">
                        {
                          errors.lugar.message
                        }</p>
                    )
                  }              
              </div>
            </div>
          </div>

          <div className="row g-0 d-flex">
            <div className="col-sm-6 m-auto">
              <div className="form-group blocks">
                <label htmlFor="especialidad" className="label-style">Especialidad</label>
                <select onClick={(e) => changeValue(Number(e.target.value))} id="especialidad" className="form-control rounded-0 border-0 border-end border-bottom productos-select"
                  {...register("especialidad", {
                    required: {
                      value: true,
                      message: "Este campo es requerido."
                    }
                  })}
                  isClearable={true}

                >
                  <option value={-1} ></option>

                    {
                      especialidades.map(v => <option onChange={() => changeValue(v.id_especialidad)} key={
                        v.id_especialidad
                      }
                        value={
                          v.id_especialidad
                        }>
                        {
                          v.especialidad_name
                        }</option>)
                    }                  
                    {/* <option value={-1}>No lo sé</option> */}
                </select>
                
                <div className="mt-3 mb-3">
                  <p className="texto_especialidad">

                  {
                   valueEspecialidad === -1  ? "" : especialidades[valueEspecialidad-1].short_description
                }
                  </p>
                </div>
              
                {
                    errors?.especialidad?.type === "required" && (
                      <p className="warning-message" >
                        {
                          errors.especialidad.message
                        }</p>
                    )
                  }              
              </div>
            </div>
          </div>

          {
              ( registrado === true ) && (
                <div className="col-sm-6 m-auto">
                <div className='form-group w-100'>
                  <button type='button' className='btn btn-primary btn-block rounded-0 btn-style'
                    onMouseOver={
                      (e) => {
                        e.target.style.border = '1px solid #c0c0c0';
                        e.target.style.color = '#c0c0c0';
                      }
                    }
                    onMouseOut={
                      (e) => {
                        e.target.style.border = '1px solid #007bff';
                        e.target.style.color = '#007bff';
                      }
                    }
                    onClick={onMeeting}>Pagar</button>
                </div>
              </div>
              )

          }
          <div className="row mt-4 mb-4">
            <div className="col-sm-6 m-auto">
              <div className='form-group w-100'>
                <button type='submit' className='btn btn-primary btn-block rounded-0 btn-style'
                  onMouseOver={
                    (e) => {
                      e.target.style.border = '1px solid #c0c0c0';
                      e.target.style.color = '#c0c0c0';
                    }
                  }
                  onMouseOut={
                    (e) => {
                      e.target.style.border = '1px solid #007bff';
                      e.target.style.color = '#007bff';
                    }
                  }
                  >{registrado===false?'Registrar':'Cancelar'}</button>
              </div>
            </div>
          </div>
{/*
          {
                ( registrado === true ) && (
                    <div className='row mb-4'>

                        <div className="col-sm-4">

                        </div>


                        <div className="col-sm-3 mt-3">

                          <button type="button" onClick={onMeeting} style={{borderRadius:'10px' , backgroundColor : '#badae5' , color :'white'}}>Pagar</button>

                        </div>

                    </div> 
                )
            }

*/}


        </Form>

        <DialogCard isvisible={isVisible} answer={theAnswer}
          notVisible={() => theNotVisible()}></DialogCard>
  
          <Toast ref={toast} />
      </div>
      <div className=" mt-5">
        <Footer oscuro={true}/>
      </div>
      
    </>
  )
}
